import { customerApi } from "../../utils/apiConfig";

export const boruProfilDaily = (date) => {
  return customerApi.post("/getBoruProfilUretimDaily", date ? { date } : {}, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getMachineSpeed = () => {
  return customerApi.get(`/getMachineSpeed`, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getBoruProfilUretimDetail = (documentId) => {
  return customerApi.post(
    "/getBoruProfilUretimDetail",
    { documentId },
    {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    }
  );
};

export const updateBoruProfilUretim = (payload) => {
  return customerApi.post("/updateBoruProfilUretim", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getBoruProfilUretimGunlukAnaliz = (startDate, endDate, makina) => {
  return customerApi.post(
    "/getBoruProfilUretimGunlukAnaliz",
    {
      startDate,
      endDate,
      makina,
    },
    {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    }
  );
};

export const getOperatorDurusKpiAnalysis = (startDate, endDate, makina) => {
  return customerApi.post(
    "/getOperatorDurusKpiAnalysis",
    {
      startDate,
      endDate,
      makina,
    },
    {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    }
  );
};
